import { Outlet } from 'react-router-dom';
import { Icon } from '@iconify/react';
import { Sidebar } from './Sidebar';
import { useAutoSave } from '../../hooks/useAutoSave';
import { useNotairesSync } from '../../hooks/useNotairesSync';
import { useForecast } from '../../context/useForecast';

function AutoSaveSetup() {
  useAutoSave();
  return null;
}

function NotairesSync() {
  useNotairesSync();
  return null;
}

function ReadOnlyBanner() {
  const { canWrite, forecastName } = useForecast();
  if (canWrite) return null;
  return (
    <div className="flex items-center gap-2 px-4 py-2 text-xs font-medium bg-amber-50 border-b border-amber-200 text-amber-800">
      <Icon icon="lucide:eye" className="w-3.5 h-3.5 shrink-0" />
      <span>
        Lecture seule — vous n'avez pas les droits d'édition sur le scénario
        <span className="font-semibold"> « {forecastName} »</span>. Vos modifications
        ne seront pas enregistrées.
      </span>
    </div>
  );
}

export function AppShell() {
  return (
    <div className="flex h-screen bg-background overflow-hidden">
      <AutoSaveSetup />
      <NotairesSync />
      <Sidebar />
      <main className="flex-1 overflow-y-auto bg-background">
        <ReadOnlyBanner />
        <div className="p-6">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
